export enum Resource {
    HOME = 'Home',
    PRISE_CARBURANT = 'PriseCarburant',
    PAIEMENT = 'Paiement',
    CARTE = 'Carte',
    COMPTE_UTILISATEUR = 'CompteUtilisateur',
    POINT_OF_SALE_MASTER_DATA = 'PointOfSaleMasterData',
    JOURNALISATION = 'Journalisation',
    LOG = 'Log',
    OCRD = 'Ocrd',
    ROLE_RESSOURCE_PORTAIL = 'RoleRessourcePortail',
    ABOUT = 'About',
    RELEVE_CLIENT = 'ReleveClient',
    LIVRAISON_CARTE_REPORT = 'LivraisonCarteReport',
    PRIX = 'Prix',
}
